import { Category } from "@/types";

export const isOnlyLand = (categoriesValue: Category[]) => {
  return categoriesValue?.length === 1 && categoriesValue[0]?.code === "0";
};
